import React, { useState } from 'react';

/**
 * FilterPanel component for filtering projects.
 * @param {Object} props - The component props.
 * @param {Function} props.onFiltersChange - The function to be called when filters change.
 * @returns {JSX.Element} The rendered FilterPanel component.
 */
export default function FilterPanel({ onFiltersChange }) {
    const [selectedType, setSelectedType] = useState('All');
    const [selectedTechnology, setSelectedTechnology] = useState('');

    const [isTypeFilterActive, setIsTypeFilterActive] = useState(false);
    const [isTechnologyFilterActive, setIsTechnologyFilterActive] = useState(false);


    const handleApplyFilters = () => {
        const filters = {
            type: isTypeFilterActive ? selectedType : null,
            technology: isTechnologyFilterActive ? selectedTechnology : null
        };
        onFiltersChange(filters);
    }

    const handleTypeFilterChange = (event) => {
        setSelectedType(event.target.value);
    };


    const toggleTypeFilter = () => {
        setIsTypeFilterActive(!isTypeFilterActive);
    };

    const toggleTechnologyFilter = () => {
        setIsTechnologyFilterActive(!isTechnologyFilterActive);
    }

    const handleTechnologyFilterChange = (event) => {
        setSelectedTechnology(event.target.value);
    }

    return (
        <div className='mt-8'>
            <h2 className='text-black px-6 text-lg font-semibold'>Filter By</h2>
            <div className='mt-4'>
                <div className='flex flex-col px-6'>
                    <label className='inline-flex intems-center mt-3'>
                        <input className='form-checkbox h-5 w-5 text-black' type='checkbox' checked={isTypeFilterActive} onChange={toggleTypeFilter} />
                        <span className='ml-2 text-black'>Project Type</span>
                    </label>
                    {isTypeFilterActive && (
                        <select value={selectedType} onChange={handleTypeFilterChange}>
                            <option value="">Select Project Type...</option>
                            <option value="web">Web Development</option>
                            <option value="mobile">Mobile Applications</option>
                            <option value="desktop">Desktop Applications</option>
                            <option value="game">Game Development</option>
                            <option value="research">Research & Development</option>
                        </select>
                    )}
                    <label className='inline-flex intems-center mt-3'>
                        <input className='form-checkbox h-5 w-5 text-black' type='checkbox' checked={isTechnologyFilterActive} onChange={toggleTechnologyFilter}/>
                        <span className='ml-2 text-black'>Technology Used</span>
                    </label>
                    {isTechnologyFilterActive && (
                        <select value={selectedTechnology} onChange={handleTechnologyFilterChange}>
                            <option value={""}>Select technology used...</option>
                            <option value={"react"}>React</option>
                            <option value={"cpp"}>C++</option>
                            <option value={"csharp"}>C#</option>
                            <option value={"python"}>Python</option>
                        </select>
                    )}
                </div>
            </div>
            <div className='mt-auto flex items-center justify-center py-6'>
                <button className='px-6 py-2 text-white bg-black rounded-lg' onClick={handleApplyFilters}>Apply Filters</button>
            </div>
        </div>
    )
}